import { getPaginated, getApi } from 'util/backendapi/fetch';
import {
  makeReportingDuck,
  ReportingDuckActions,
} from 'ducks/make-reporting-duck';

export const auditLogsListDuck = makeReportingDuck(
  'auditLog',
  (filters) => getPaginated('/reports/audit-log/', filters),
  () => getApi('/reports/audit-log/info/')
);

export type AuditLogListActions = ReportingDuckActions<
  typeof auditLogsListDuck
>;
